import { useTracking } from 'react-tracking';

import { RouterLink } from '@redux-first-router-link';

import { Grid, Box, Text } from '@simplywallst/ui-core';

import { ROUTE_ARTICLE } from '@/constants/routes';

type ArticleDescriptionProps = {
  excerpt: string;
  slug: string;
};
export const Excerpt = ({ excerpt, slug }: ArticleDescriptionProps) => {
  const { trackEvent } = useTracking();
  return (
    <Grid paddingTop="x0_5" paddingBottom="x0_5">
      <Box
        paddingTop="x1"
        paddingRight="x3"
        paddingLeft="x3"
        data-cy-id="article-card-excerpt"
      >
        <Text typography="xSmall" lineClamp={3}>
          {excerpt}
        </Text>
      </Box>
      <Box
        paddingBottom="x1"
        paddingRight="x3"
        paddingLeft="x3"
        data-cy-id="article-card-excerpt"
      >
        <RouterLink
          noUnderline
          to={{
            type: ROUTE_ARTICLE,
            payload: { slug },
          }}
          onClick={() => {
            trackEvent({
              modifier: 'market-latest-article',
              action: 'click',
              slug,
            });
          }}
        >
          <Text typography="xSmall" color="brand01">
            Continue reading
          </Text>
        </RouterLink>
      </Box>
    </Grid>
  );
};
